import { isAxiosError } from 'axios';

/**
 * True when the admin Sentry test API failed with HTTP 500, the status the
 * test endpoint uses when it throws. Other Axios failures (401, 403, network)
 * are not a successful test throw.
 */
export const isSentryTestServerThrow = (error: unknown): boolean =>
  isAxiosError(error) && error.response?.status === 500;
